import { render } from "./inputNumber.vue?vue&type=template&id=10e8d841&scoped=true"
import script from "./inputNumber.vue?vue&type=script&lang=js"
export * from "./inputNumber.vue?vue&type=script&lang=js"

import "./inputNumber.vue?vue&type=style&index=0&id=10e8d841&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e8d841"]])

export default __exports__